module.exports = __webpack_public_path__ + "static/media/homeCustom2.01ddca45.jpg";